import {
  createContext, ReactNode, useMemo, useState,
} from 'react';
import { OnHoverEvent } from 'types/openlayers.types';

interface LayerViewContextValues {
    onHoverEvent?: OnHoverEvent,
    captureOnHoverEvent: (event: OnHoverEvent) => void,
}

const LayerViewContext = createContext<LayerViewContextValues>({
  onHoverEvent: undefined,
  captureOnHoverEvent: () => {},
});

interface LayerViewProviderProps {
    children: ReactNode
}

function LayerViewProvider({ children } : LayerViewProviderProps) {
  const [onHoverEvent, captureOnHoverEvent] = useState<OnHoverEvent>();

  return (
    <LayerViewContext.Provider value={useMemo(() => ({
      captureOnHoverEvent,
      onHoverEvent,
    }), [onHoverEvent])}
    >
      {children}
    </LayerViewContext.Provider>
  );
}

export { LayerViewProvider };
export default LayerViewContext;
